import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../services/spinner.service';
import { ApiLanguage, ApiSetLanguagesRequest } from '../../api-client-module';
import { Language } from '../../firestore-models/language';
import { SelectLangFileDialogComponent } from '../../select-lang-file-dialog/select-lang-file-dialog.component';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

export interface LanguageDialogData {
  change_type: number;
  language?: ApiLanguage;
}

@Component({
  selector: 'app-language-dialog',
  templateUrl: './language-dialog.component.html',
  styleUrls: ['./language-dialog.component.css'],
  standalone: false,
})
export class LanguageDialogComponent implements OnInit {

  //言語情報
  language?: ApiLanguage;
  isAdded: boolean = false;
  languages!: Array<Language>;

  //言語情報フォーム
  languageFormGroup!: FormGroup;
  langCodeControl!: FormControl;
  langNameControl!: FormControl;
  displayNameControl!: FormControl;
  langNameEnControl!: FormControl;
  transLangCodeControl!: FormControl;
  ttsLangCodeControl!: FormControl;
  ttsVoiceCodeMControl!: FormControl;
  ttsVoiceCodeFControl!: FormControl;

  constructor(
    public dialogRef: MatDialogRef<LanguageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LanguageDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.language = this.data.language;
    if (!this.language) {
      this.language = {
        lang_code: '',
        lang_name: '',
        lang_name_en: '',
        display_name: '',
        lang_file: '',
        trans_lang_code: '',
        tts_lang_code: '',
        tts_voice_codes: [
          { code: '', name: this.translate.instant('男性') },
          { code: '', name: this.translate.instant('女性') },
        ],
        enabled: true
      };
      this.isAdded = true;

    }
    this.createForm();
    this.langCodeControl = this.languageFormGroup.get('langCode') as FormControl;
    this.langNameControl = this.languageFormGroup.get('langName') as FormControl;
    this.displayNameControl = this.languageFormGroup.get('displayName') as FormControl;
    this.langNameEnControl = this.languageFormGroup.get('langNameEn') as FormControl;
    this.transLangCodeControl = this.languageFormGroup.get('transLangCode') as FormControl;
    this.ttsLangCodeControl = this.languageFormGroup.get('ttsLangCode') as FormControl;
    this.ttsVoiceCodeMControl = this.languageFormGroup.get('ttsVoiceCodeM') as FormControl;
    this.ttsVoiceCodeFControl = this.languageFormGroup.get('ttsVoiceCodeF') as FormControl;

  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToLangCode() {

    return this.langCodeControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToLangName() {
    return this.langNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToDisplayName() {
    return this.displayNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToDisplayNameEn() {
    return this.langNameEnControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToTransLangCode() {
    return this.transLangCodeControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToTtsLangCode() {
    return this.ttsLangCodeControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToTtsVoiceCodeM() {
    return this.ttsVoiceCodeMControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToTtsVoiceCodeF() {
    return this.ttsVoiceCodeFControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.languageFormGroup = this.formBuilder.group(
      {
        langCode: [this.language!.lang_code, [Validators.required]],
        langName: [this.language!.lang_name, [Validators.required]],
        langNameEn: [this.language!.lang_name_en, [Validators.required]],
        displayName: [this.language!.display_name, [Validators.required]],
        transLangCode: [this.language!.trans_lang_code, [Validators.required]],
        ttsLangCode: [this.language!.tts_lang_code, [Validators.required]],
        ttsVoiceCodeM: [this.language!.tts_voice_codes[0].code],
        ttsVoiceCodeF: [this.language!.tts_voice_codes[1].code],
      }
    );
  }

  //更新ボタン
  addLanguage(): void {
    if (this.languageFormGroup.valid) {
      this.language!.lang_code = this.langCodeControl.value;
      this.language!.lang_name = this.langNameControl.value;
      this.language!.lang_name_en = this.langNameEnControl.value;
      this.language!.display_name = this.displayNameControl.value;
      this.language!.trans_lang_code = this.transLangCodeControl.value;
      this.language!.tts_lang_code = this.ttsLangCodeControl.value;
      this.language!.tts_voice_codes = [
        { 'code': this.ttsVoiceCodeMControl.value, 'name': this.translate.instant('男性') },
        { 'code': this.ttsVoiceCodeFControl.value, 'name': this.translate.instant('女性') }
      ]
      if (this.language) {
        let request: ApiSetLanguagesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          languages: [this.language]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setLanguages(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じコードが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //アイコン画像ダイアログ
  openSelectLangFileDialog(): void {
    const dialogRef = this.dialog.open(SelectLangFileDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: {
        langFile: null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let isChanged: boolean = false;
      if (!!result) {
        this.language!.lang_file = result.download_url;
      }
    });
  }

  //
  deleteLangFile(): void {
    if (!!this.language!.lang_file) {
      this.language!.lang_file = '';
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
